import {
  MerchantAppReturnZodSchema,
  MerchantAppReturnZodSchema_,
} from "@redotech/redo-return-core-common/return";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const InitialReturnUpdate_ = z.object({
  type: z.literal("initial"),
  data: MerchantAppReturnZodSchema,
});

const PartialReturnUpdate_ = z.object({
  type: z.literal("update"),
  updatedFields: z.partialRecord(z.keyof(MerchantAppReturnZodSchema_), z.any()),
});

export const watchReturn = unaryStreamRpc({
  name: "watchReturn",
  input: z.object({
    returnId: z.string(),
    skipInitial: z.boolean().optional(),
    locale: z.string().max(35).optional(),
  }),
  output: z.discriminatedUnion("type", [
    InitialReturnUpdate_,
    PartialReturnUpdate_,
  ]),
});
